import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { post } from 'helpers/api';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { getProfileData } from '../../../helpers/preview';
import { showSnackbar } from 'components/ui/snackbar/helper';
import { fetchTranslation } from '../../../../../helpers/i18n';

const EMAIL_STATES = {
  NOT_SENT: 'not_sent',
  SENDING: 'sending',
  SENT: 'sent'
};

export default function SendVerifyEmail({ email, readonly = false, sendVerificationPath }) {
  const [emailState, setEmailState] = useState(EMAIL_STATES.NOT_SENT);

  function sendEmail() {
    setEmailState(EMAIL_STATES.SENDING);
    const previewProfile = getProfileData();
    post(sendVerificationPath, { readonly, previewProfile }).then(() => {
      setEmailState(EMAIL_STATES.SENT);
      showSnackbar({ text: fetchTranslation('successfully_sent_email_verification'), variant: 'success' });
    });
  }

  const buttonText = {
    [EMAIL_STATES.NOT_SENT]: fetchTranslation('send_verification_email'),
    [EMAIL_STATES.SENDING]: fetchTranslation('sending_verification_email'),
    [EMAIL_STATES.SENT]: fetchTranslation('email_verification_sent'),
  }[emailState];
  const sendEmailDisabled = [EMAIL_STATES.SENDING, EMAIL_STATES.SENT].includes(emailState);

  const displayEmail = () => {
    if (readonly) {
      const previewProfile = getProfileData();

      return previewProfile.attributes.login_credential_attributes.email;
    } else {
      return email;
    }
  };

  return (
    <div className="text-center">
      <FontAwesomeIcon className="mb-6 mt-2 text-branding" icon={faClock} size="2x"/>
      <h5 className="mb-6">
        <strong>{fetchTranslation('verify_your_email_address')}</strong>
      </h5>
      <p>
        {fetchTranslation('we_need_to_verify_email', { email: displayEmail() })}
      </p>
      <p className="text-muted">
        <small>
          {fetchTranslation('verification_email_help_text')}
        </small>
      </p>
      <div className="text-center mt-6 mb-2">
        <Button disabled={sendEmailDisabled} variant="primary" onClick={sendEmail}>{buttonText}</Button>
      </div>
    </div>
  );
}

SendVerifyEmail.propTypes = {
  email: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  sendVerificationPath: PropTypes.string.isRequired
};
